function calculateBMI(height_meter: number, weight_kg: number) {
    return Math.floor(weight_kg / Math.pow(height_meter, 2));
}

export default calculateBMI;